export default "__VITE_ASSET__DRLVtS5m__"